import React from 'react';
import './CardSnippet.css';

const CardSnippet = () => {
  return (
    <pre>
      <code>
        
      <span class="cn">&lt;div</span> <span class="cln">class="</span><span class="cn">carve-card</span><span class="cln">"&gt;</span>
<br />
&nbsp;&nbsp;<span class="cn">&lt;div</span> <span class="cln">class="</span><span class="cn">carve-card-head</span><span class="cln">"&gt;</span>
<br />
&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span> <span class="cln">class="</span><span class="cn">heading-medium</span><span class="cln">"&gt;</span>card header<span class="cn">&lt;/div&gt;</span>
<br />
&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span>
<br />
&nbsp;&nbsp;<span class="cn">&lt;div</span> <span class="cln">class="</span><span class="cn">carve-card-body</span><span class="cln">"&gt;</span>
<br />
&nbsp;&nbsp;&nbsp;&nbsp;Lorem ipsum dolor, sit amet consectetur adipiscing elit. Dolore quod maxime illo, veritatis ea quisquam voluptate. Corrupti, nisi reprehenderit rem dolorem rerum nulla obcaecati, quidem, deleniti deserunt itaque odit officia!
<br />
&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span>
<br />
&nbsp;&nbsp;<span class="cn">&lt;div</span> <span class="cln">class="</span><span class="cn">carve-card-footer</span><span class="cln">"&gt;</span>
<br />
&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span> <span class="cln">class="</span><span class="cn">carve-button-group</span><span class="cln">"&gt;</span>
<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;button</span> <span class="cln">class="</span><span class="cn">carve-button-vice carve-button-block</span><span class="cln">"&gt;</span>save<span class="cn">&lt;/button&gt;</span>
<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;button</span> <span class="cln">class="</span><span class="cn">carve-button-main carve-button-block</span><span class="cln">"&gt;</span>cancel<span class="cn">&lt;/button&gt;</span>
<br />
&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span>
<br />
&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span>
<br />
<span class="cn">&lt;/div&gt;</span>




      </code>
    </pre>
  );
}

CardSnippet.propTypes = {};

export default CardSnippet;
